<template>
  <div class="step-four text-center py-8">
    <v-icon size="80" color="success" class="mb-4">mdi-check-circle-outline</v-icon>

    <h2 class="text-h5 mb-4">{{ $t('onboarding.step4.success-title') }}</h2>
    <p class="text--secondary mb-6">{{ $t('onboarding.step4.success-message') }}</p>

    <!-- Mandate Reference -->
    <v-card v-if="mandateReference" class="mb-4 pa-4" outlined>
      <div class="text-subtitle-2 mb-2">{{ $t('onboarding.step4.mandate-reference') }}</div>
      <div class="text-h6 primary--text">{{ mandateReference }}</div>
    </v-card>



    <div class="mt-6">
      <v-btn text small @click="closeWindow">
        {{ $t('close') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepFour',

  props: {
    mandateReference: {
      type: String,
      default: null
    },
    mandateUrl: {
      type: String,
      default: null
    }
  },

  methods: {
    closeWindow() {
      // Try to close window (only works if opened via window.open)
      window.close()

      // If still open, show message
      setTimeout(() => {
        if (!window.closed) {
          alert(this.$t('onboarding.step4.close-manually'))
        }
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.step-four {}
</style>
